/**
 * The PDF engine's own floor, asked WITHOUT loading the engine and only AFTER a load has failed.
 *
 * pdfjs-dist 6.3 references the `Iterator` global at module scope (Safari and iOS 18.4, Chrome 122,
 * Firefox 131 and newer have it), so on an older browser the engine's chunk throws on its first
 * statement and the deferred load stays failed for the page's lifetime. The two hosts branch their
 * error face on this: a browser WITH the global gets the ordinary retry face (a reload, the load may
 * have failed for a passing reason), a browser WITHOUT it gets a plain notice that PDF previews need
 * a newer browser, with no retry that could never work. Nothing else about the preview changes.
 *
 * Deliberately not a pre-check: the hosts never refuse a browser before the engine has actually
 * failed there, so a future pdfjs that drops the reference keeps working on those browsers with
 * no change here. Lives outside the engine folder because the boundary Fact keeps the hosts'
 * imports from that folder to the viewer class; the same Fact pins that this names the global
 * the installed engine references, so a pdfjs bump that drops it turns that row red and this
 * check is revisited. The floor itself is re-derived by `Scripts/boot-floor/api-floor-probe.mjs`
 * (BROWSER_SUPPORT.md §4).
 */
export function pdfEngineCanRun(): boolean {
  return typeof (globalThis as { Iterator?: unknown }).Iterator === 'function';
}
